/* Kona Love: small helpers for the kl-* sections. No dependencies. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function playHero(root) {
    var hv = root.querySelector('video[data-kl-hero]');
    if (!hv) return;
    if (reduce) { hv.pause(); hv.style.display = 'none'; return; }
    var p = hv.play();
    if (p && p.catch) p.catch(function () { hv.style.display = 'none'; });
  }

  function loadVid(v) {
    var s = v.querySelector('source[data-src]');
    if (s) { s.src = s.getAttribute('data-src'); s.removeAttribute('data-src'); v.load(); }
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) {
        loadVid(v);
        if (!reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      } else { v.pause(); }
    });
  }, { rootMargin: '200px 0px' }) : null;

  function lazyLoops(root) {
    root.querySelectorAll('video[data-kl-lazy]').forEach(function (v) {
      if (io) io.observe(v); else loadVid(v);
    });
  }

  function youtube(root) {
    root.querySelectorAll('[data-kl-yt]').forEach(function (btn) {
      if (btn.dataset.klBound) return;
      btn.dataset.klBound = '1';
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-kl-yt');
        var f = document.createElement('iframe');
        f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1';
        f.allow = 'autoplay; encrypted-media; picture-in-picture';
        f.allowFullscreen = true;
        f.title = btn.getAttribute('aria-label') || 'Video';
        btn.innerHTML = '';
        btn.appendChild(f);
        btn.style.cursor = 'default';
      });
    });
  }

  // close header dropdowns and the phone menu on outside click or Escape
  function closeMenus(except) {
    document.querySelectorAll('.kl details[open][data-kl-menu]').forEach(function (d) {
      if (d !== except) d.removeAttribute('open');
    });
  }
  document.addEventListener('click', function (e) {
    var d = e.target.closest('details[data-kl-menu]');
    closeMenus(d);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenus(null); });

  // Preview helper: send page links to the new templates (?view=) until they are assigned in Pages.
  // Also keeps absolute konalovecoffee.com links on the current domain, so a theme preview stays in preview.
  function viewLinks(root) {
    var map = window.KL_VIEWS;
    if (!map) return;
    root.querySelectorAll('a[href]').forEach(function (a) {
      var u;
      try { u = new URL(a.getAttribute('href'), location.href); } catch (e) { return; }
      var ours = u.host === location.host || /(^|\.)konalovecoffee\.com$/.test(u.hostname);
      if (!ours) return;
      var path = u.pathname.replace(/\/$/, '');
      var view = map[path];
      if (!view) return;
      if (!u.searchParams.get('view')) u.searchParams.set('view', view);
      a.setAttribute('href', path + '?' + u.searchParams.toString() + u.hash);
    });
  }


  // Product media on mobile: keep Dawn's slider, add overlay arrows and make the
  // slider height follow the image on screen so short and tall photos both sit flush.
  function klProductMedia(root) {
    var mq = window.matchMedia('(max-width:749px)');
    root.querySelectorAll('.product__media-wrapper').forEach(function (wrap) {
      var list = wrap.querySelector('ul.product__media-list.slider--mobile');
      if (!list || wrap.dataset.klMedia) return;
      wrap.dataset.klMedia = '1';

      function fit() {
        if (!mq.matches) { list.style.height = ''; return; }
        var slides = [].slice.call(list.querySelectorAll('.product__media-item'));
        if (slides.length < 2) { list.style.height = ''; return; }
        var center = list.scrollLeft + list.clientWidth / 2;
        var best = slides[0], bd = Infinity;
        slides.forEach(function (s) {
          var m = s.offsetLeft + s.offsetWidth / 2, d = Math.abs(m - center);
          if (d < bd) { bd = d; best = s; }
        });
        var mc = best.querySelector('.product-media-container') || best;
        var h = mc.getBoundingClientRect().height;
        if (h > 10) list.style.height = Math.round(h) + 'px';
      }

      var prev = document.createElement('button');
      prev.type = 'button'; prev.className = 'kl-arrow kl-prev'; prev.setAttribute('aria-label', 'Previous image');
      prev.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"/></svg>';
      var next = document.createElement('button');
      next.type = 'button'; next.className = 'kl-arrow kl-next'; next.setAttribute('aria-label', 'Next image');
      next.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>';
      function step(dir) { list.scrollBy({ left: dir * list.clientWidth, behavior: 'smooth' }); }
      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
      function toggleArrows() {
        var many = list.querySelectorAll('.product__media-item').length > 1;
        prev.hidden = next.hidden = !(mq.matches && many);
      }
      wrap.appendChild(prev); wrap.appendChild(next);
      toggleArrows();

      var t;
      list.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(fit, 70); }, { passive: true });
      window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(function () { fit(); toggleArrows(); }, 120); });
      list.querySelectorAll('img').forEach(function (im) { if (!im.complete) im.addEventListener('load', fit); });
      setTimeout(fit, 250); setTimeout(fit, 900);
    });
  }

  function init(root) { playHero(root); lazyLoops(root); youtube(root); viewLinks(root); klProductMedia(root); }
  init(document);
  // theme editor: re-run when a section is added or changed
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
